// frontend/src/services/echo.js
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: Number(import.meta.env.VITE_REVERB_PORT) || 80,
  wssPort: Number(import.meta.env.VITE_REVERB_PORT) || 443,
  forceTLS: false,
  enabledTransports: ['ws', 'wss'],
  enableStats: false, // <- silencia o warning do Pusher
  cluster: 'mt1',     // seguro mesmo sem uso (evita logs em algumas versões)
  authEndpoint: (import.meta.env.VITE_API_URL || 'http://localhost:8000/api').replace('/api', '/api/broadcasting/auth'),
  auth: { 
    headers: {
      // ⚠️ CRÍTICO: Função dinâmica para pegar token atualizado do localStorage
      get Authorization() {
        const token = localStorage.getItem('auth_token');
        return token ? `Bearer ${token}` : '';
      }
    }
  },
});

export default echo;
